import { Component, Input, OnInit } from '@angular/core';
import { CycleBcModel } from 'src/app/shared/models/societe-linked/bc/cycle-bc.model';
import { NTHFlag } from 'src/app/shared/constants/flag';

@Component({
  selector: 'app-cycles-bc',
  templateUrl: './cycles-bc.component.html',
  styleUrls: ['./cycles-bc.component.scss']
})
export class CyclesBcComponent implements OnInit {

  @Input() title:string;
  @Input() cycles:CycleBcModel[];

  constructor() { }

  ngOnInit(): void {
  }

  getSortedArrayByDate(): CycleBcModel[] {
    const arraySorted = this.cycles.sort((a: CycleBcModel, b: CycleBcModel) => {
      return +new Date(b.dAction) - +new Date(a.dAction);
    });
    return arraySorted;
  }

  getStyle(litigeFlag) {
    switch(litigeFlag) {
      case NTHFlag.None: {
        return 'black';
      }
      case NTHFlag.Some: {
        return 'red';
      }
      case NTHFlag.All: {
        return 'green';
      }
    }
  }

}
